import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';

import useClerkLoginState from '../../utils/useClerkLoginState';
import LoadingContainer from '../LoadingContainer';

export default function PrivateRouteComponent({ children }) {
	const state = useClerkLoginState();

	return (
		<>
			<SignedOut>
				<Navigate to="/login" />
			</SignedOut>
			<SignedIn>
				{(!state || state === 'loading') && <LoadingContainer />}
				{state === 'logged-in' && children}
				{state === 'no-organisation' && (
					<>
						<p>You&apos;re not connected to any retailer accounts.</p>
					</>
				)}
			</SignedIn>
		</>
	);
}
